var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.17,
    cx: 12.25,
    cy: 11,
    r: 9,
    fill: "url(#paint0_linear_1011_218568)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11,
    r: 10,
    stroke: "url(#paint1_linear_1011_218568)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28827 14.2065C7.09609 13.7968 7 13.3383 7 12.8309C7 12.3111 7.088 11.8453 7.26399 11.4336C7.43999 11.0218 7.67161 10.6954 7.95887 10.4541C8.24613 10.2129 8.5617 10.0923 8.9056 10.0923H9.79164C10.1153 9.65565 10.3894 9.28655 10.614 8.98503C10.8385 8.68352 11.0337 8.41423 11.1996 8.17718C11.3655 7.94012 11.5182 7.70411 11.6578 7.46913C11.7974 7.23415 11.94 6.96902 12.0856 6.67374C12.207 6.43253 12.3274 6.25994 12.4467 6.15597C12.5661 6.05199 12.7107 6 12.8807 6C13.1072 6 13.2943 6.07902 13.442 6.23706C13.5897 6.3951 13.6635 6.5968 13.6635 6.84217C13.6635 7.06259 13.6241 7.29549 13.5452 7.54087C13.4663 7.78624 13.3753 8.02954 13.2721 8.27075C13.1689 8.51196 13.0789 8.73758 13.002 8.9476C12.9252 9.15763 12.8867 9.3375 12.8867 9.48722C12.8867 9.61198 12.9343 9.71387 13.0293 9.79289C13.1244 9.87191 13.2549 9.91142 13.4208 9.91142H15.0593C15.3223 9.91142 15.5448 10.006 15.7269 10.1953C15.909 10.3845 16 10.6143 16 10.8846C16 11.2007 15.909 11.4356 15.7269 11.5895C15.8685 11.7351 15.9393 11.9534 15.9393 12.2445C15.9393 12.4151 15.9029 12.5741 15.8301 12.7218C15.7573 12.8694 15.6602 12.9786 15.5388 13.0493C15.6521 13.199 15.7087 13.4028 15.7087 13.6606C15.7087 14.0516 15.5246 14.3427 15.1564 14.534C15.2293 14.6754 15.2657 14.823 15.2657 14.9769C15.2657 15.2015 15.1929 15.3918 15.0472 15.5477C14.9016 15.7037 14.7013 15.817 14.4464 15.8877C14.3048 15.9293 14.1207 15.9584 13.8941 15.975C13.6676 15.9917 13.4127 16 13.1295 16H12.4983C12.1301 16 11.7822 15.9605 11.4545 15.8815C11.1268 15.8025 10.1527 15.648 9.87355 15.5024L9.07553 15.5446C8.70735 15.5446 8.36548 15.424 8.0499 15.1828C7.73432 14.9416 7.48044 14.6161 7.28827 14.2065Z",
    fill: "url(#paint2_linear_1011_218568)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_218568",
    x1: 12.106,
    y1: 1.208,
    x2: 12.394,
    y2: 20.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1011_218568",
    x1: 21.7712,
    y1: -2.92858,
    x2: 5.51229,
    y2: -2.18077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1011_218568",
    x1: 11.5,
    y1: 6,
    x2: 11.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.5a6b505bbee0bd8d294b48b711a348d3.svg";
export { ForwardRef as ReactComponent };